// import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';
import { toURLSearchParams } from '@/utils/url';

import { type TariffsSearchParams, tariffsApiSchema } from '../../models';
import { logger } from '../../utils/logger';

const tariffs = fetcher.extend(() => ({ prefixUrl: `${API.TARIFFS}` }));

export const fetchTariffs = async (
  searchParams: TariffsSearchParams,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await tariffs
      .get('search', { searchParams: toURLSearchParams(searchParams), signal })
      .json(tariffsApiSchema);
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
